import React from "react"

const AreaCalcContext = React.createContext({})

export default AreaCalcContext
